import { css } from "@emotion/css"
import React from "react"

import Spacer from "@p-ban/common/src/components/layout/Spacer"
import { commaFormat } from "@p-ban/common/src/utils/NumberUtils"

import OneClickDivider from "../../components/1Click/OneClickDivider"
import COLOR_CODE from "../../constant/color"

type Props = {
  discounts: {
    name: string
    amount: number
  }[]
}

const Discount = ({ discounts }: Props) => {
  return (
    <div className={style}>
      {discounts.map((discount, i) => (
        <React.Fragment key={i}>
          <p>
            <span>{discount.name}</span>
            <span>
              <span>{commaFormat(discount.amount)}</span>円
            </span>
          </p>
          <OneClickDivider />
        </React.Fragment>
      ))}
      <Spacer size={4} />
    </div>
  )
}

export default Discount

const style = css`
  > p {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 1;

    > span:first-child {
      font-weight: 500;
      color: ${COLOR_CODE.LIGHT_BLACK2};
      letter-spacing: -0.03em;
    }
    > span:nth-child(2) {
      color: ${COLOR_CODE.RED};
      > span {
        font-size: 15px;
        font-weight: bold;
      }
    }
  }
`
